"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "mb-6 text-lg font-semibold leading-7.5" };
const store_1 = require("@/state/store");
const SharedButton_vue_1 = __importDefault(require("@SharedVueComponents/SharedButton.vue"));
const sharedFunctions_1 = require("@/services/sharedFunctions");
const main_1 = require("@/main");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BottomLoginRegisterToggle',
    setup(__props) {
        return (_ctx, _cache) => {
            return (!(0, vue_2.unref)(store_1.store).isLandingPage)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("h3", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)((0, vue_2.unref)(store_1.store).isLogin ? "login.switch_headline" : "registration.switch_headline")), 1),
                    (0, vue_2.createVNode)(SharedButton_vue_1.default, {
                        variant: "secondary",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(sharedFunctions_1.switchLoginAndRegister)('Bottom')))
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)((0, vue_2.unref)(store_1.store).isLogin ? "login.switch_action" : "registration.switch_action")), 1)
                        ]),
                        _: 1
                    })
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
